import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

export interface Ranking {
  label: string;
  value: string;
  percentage: number;
}

@Component({
  selector: 'app-card-ranking',
  standalone: true,
  imports: [CommonModule, Skeleton],
  templateUrl: './card-ranking.component.html',
  styleUrl: './card-ranking.component.css',
})
export class CardRankingComponent {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) value!: string;
  @Input() rankings: Ranking[] = [];
  @Input() colors: string[] = [];

  constructor() {}
}
